;(function () {
  'use strict'

  angular
    .module('contrast.history')
    .factory('HistoryFactory', ['$http', 'UserService', HistoryFactory])

  function HistoryFactory($http, UserService) {
    var service = {
      getAttacksHistoryByInterval: getAttacksHistoryByInterval,
      getScoreHistory: getScoreHistory,
      getScoreHistoryByInterval: getScoreHistoryByInterval,
      getDefenseScoreHistoryByInterval: getDefenseScoreHistoryByInterval
    }

    return service

    function getAttacksHistoryByInterval(interval) {
      return $http.get(UserService.buildAPIUrl('/attack/history'), {
        params: {
          interval: interval
        }
      })
    }

    function getScoreHistory() {
      return $http.get(UserService.buildAPIUrl('/history/scores'))
    }

    function getScoreHistoryByInterval(interval) {
      return $http.get(UserService.buildAPIUrl('/history/scores/interval'), {
        params: {
          interval: interval
        }
      })
    }

    function getDefenseScoreHistoryByInterval(interval) {
      return $http.get(
        UserService.buildAPIUrl('/history/scores/interval/defense'),
        {
          params: {
            interval: interval
          }
        }
      )
    }
  }
})()
